// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"138":"4a3635ba","306":"8fc24ab9"}[chunkId] + ".css";
};